import React, { useState } from "react";
import { Button } from "../controls";
import { DownloadRounded } from "@mui/icons-material";
import { API } from "../api/api";
import { downloadBlobFromResponse, ToFormData } from "../hooks/Method";

const Export = ({ endpoint, date, label = "Export Report" }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    setLoading(true);
    API(endpoint).postFile(
      ToFormData({
        fromDate: new Date(date.fromDate).toLocaleString(),
        toDate: new Date(date.toDate).toLocaleString(),
      }),
      (res, err) => {
        setLoading(false);
        if (err) return console.error("Export failed");
        downloadBlobFromResponse(res);
      }
    );
  };

  return (
    <Button
      loading={loading}
      onClick={handleExport}
      className="w-full md:w-auto"
      variant="text"
      startIcon={<DownloadRounded />}
    >
      {label}
    </Button>
  );
};

export default Export;
